<div class="modal-header bg-soft-info p-3">
    <h5 class="modal-title" id="exampleModalLabel" i18n="@@">Accounting Configuration</h5>

    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
        (click)="close()"></button>
</div>

<div class="card-header mt-3">
    <ul ngbNav #customNav="ngbNav" [(activeId)]="activeTab"
        class="nav nav-tabs-custom card-header-tabs border-bottom-0 center justify-content-center" role="tablist">
        <li [ngbNavItem]="1" class="nav-item">
            <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                <div i18n=""> General</div>
            </a>
            <ng-template ngbNavContent>
                <div class="row g-2">
                    <div class="col-12">
                        <label for="job-title-Input" class="form-label">System</label>
                        <app-ng-select-layout [placeHolderText]="'Select a system'" [includeValidation]="true"
                            [submitted]="submitted" [(model)]="accountingConfigurationsModel!.system"
                            [items]="accountingSystemList"></app-ng-select-layout>
                        <div *ngIf="accountingConfigurationsModel!.system == undefined &&  submitted == true"
                            class='invalidInputTextMessage'>
                            <div>System Required</div>
                        </div>
                    </div>
                    <div class="col-12">
                        <label for="job-title-Input" class="form-label">Environment</label>
                        <app-ng-select-layout [placeHolderText]="'Select an environment'" [includeValidation]="true"
                            [submitted]="submitted" [(model)]="accountingConfigurationsModel!.environment"
                            [ngClass]="{ 'is-invalid': (accountingConfigurationsModel!.environment == undefined && submitted == true)}"
                            [items]="accountingEnvironmentList"></app-ng-select-layout>
                        <div *ngIf="accountingConfigurationsModel!.environment == undefined && submitted == true"
                            class='invalidInputTextMessage'>
                            <div>Environment Required</div>
                        </div>
                    </div>
                       <div class="col-12">
                        <label for="job-title-Input" class="form-label">Company Id</label>
                        <input required #companyId="ngModel" type="text"
                            [(ngModel)]="accountingConfigurationsModel!.companyId" class="form-control"
                            [ngClass]="{ 'is-invalid': (companyId.invalid && ((companyId.dirty || companyId.touched) || submitted == true))}"
                            placeholder="Enter Company Id" id="job-title-Input" />
                        <div *ngIf="companyId.invalid && ((companyId.dirty || companyId.touched) || submitted == true)"
                            class='invalidInputTextMessage'>
                            <div *ngIf="companyId.errors?.['required']">
                                <div>Company Id Required</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <label for="job-title-Input" class="form-label">Client Id</label>
                        <input required #clientId="ngModel" type="text"
                            [(ngModel)]="accountingConfigurationsModel!.clientId" class="form-control"
                            [ngClass]="{ 'is-invalid': (clientId.invalid && ((clientId.dirty || clientId.touched) || submitted == true))}"
                            placeholder="Enter Client Id" id="job-title-Input" />
                        <div *ngIf="clientId.invalid && ((clientId.dirty || clientId.touched) || submitted == true)"
                            class='invalidInputTextMessage'>
                            <div *ngIf="clientId.errors?.['required']">
                                <div>Client Id Required</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <label for="job-title-Input" class="form-label">Client Secret</label>
                        <input required #clientSecret="ngModel" type="text"
                            [(ngModel)]="accountingConfigurationsModel!.clientSecret" class="form-control"
                            [ngClass]="{ 'is-invalid': (clientSecret.invalid && ((clientSecret.dirty || clientSecret.touched) || submitted == true))}"
                            placeholder="Enter Client Secret" id="job-title-Input" />
                        <div *ngIf="clientSecret.invalid && ((clientSecret.dirty || clientSecret.touched) || submitted == true)"
                            class='invalidInputTextMessage'>
                            <div *ngIf="clientSecret.errors?.['required']">
                                <div>Client Secret Required</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <label for="job-title-Input" class="form-label">Redirect Uri</label>

                        <input required #redirectUri="ngModel" type="text"
                            [(ngModel)]="accountingConfigurationsModel!.redirectUri" class="form-control"
                            [ngClass]="{ 'is-invalid': (redirectUri.invalid && ((redirectUri.dirty || redirectUri.touched) || submitted == true))}"
                            placeholder="Enter Redirect Uri" id="job-title-Input" />
                        <div *ngIf="redirectUri.invalid && ((redirectUri.dirty || redirectUri.touched) || submitted == true)"
                            class='invalidInputTextMessage'>
                            <div *ngIf="redirectUri.errors?.['required']">
                                <div>Redirect Uri Required</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <label for="job-title-Input" class="form-label">Scope</label>
                        <input required #scope="ngModel" type="text" [(ngModel)]="accountingConfigurationsModel!.scope"
                            class="form-control"
                            [ngClass]="{ 'is-invalid': (scope.invalid && ((scope.dirty || scope.touched) || submitted == true))}"
                            placeholder="Enter Scope" id="job-title-Input" />
                        <div *ngIf="scope.invalid && ((scope.dirty || scope.touched) || submitted == true)"
                            class='invalidInputTextMessage'>
                            <div *ngIf="scope.errors?.['required']">
                                <div>Scope Required</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <label for="job-title-Input" class="form-label">State</label>

                        <input required #state="ngModel" type="text" [(ngModel)]="accountingConfigurationsModel!.state"
                            class="form-control"
                            [ngClass]="{ 'is-invalid': (state.invalid && ((state.dirty || state.touched) || submitted == true))}"
                            placeholder="Enter State" id="job-title-Input" />
                        <div *ngIf="state.invalid && ((state.dirty || state.touched) || submitted == true)"
                            class='invalidInputTextMessage'>
                            <div *ngIf="state.errors?.['required']">
                                <div>State Required</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <label for="job-title-Input" class="form-label">Discovery Document URL</label>

                        <input required #discoveryDocumentUrl="ngModel" type="text"
                            [(ngModel)]="accountingConfigurationsModel!.discoveryDocumentUrl" class="form-control"
                            [ngClass]="{ 'is-invalid': (discoveryDocumentUrl.invalid && ((discoveryDocumentUrl.dirty || discoveryDocumentUrl.touched) || submitted == true))}"
                            placeholder="Enter Discovery Document Url" id="job-title-Input" />
                        <div *ngIf="discoveryDocumentUrl.invalid && ((discoveryDocumentUrl.dirty || discoveryDocumentUrl.touched) || submitted == true)"
                            class='invalidInputTextMessage'>
                            <div *ngIf="discoveryDocumentUrl.errors?.['required']">
                                <div>Discovery Document Url Required</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <label for="job-title-Input" class="form-label">Api Base Url</label>
                        <input required #apiBaseUrl="ngModel" type="text"
                            [(ngModel)]="accountingConfigurationsModel!.apiBaseUrl" class="form-control"
                            [ngClass]="{ 'is-invalid': (apiBaseUrl.invalid && ((apiBaseUrl.dirty || apiBaseUrl.touched) || submitted == true))}"
                            placeholder="Enter Api Base Url" id="job-title-Input" />
                        <div *ngIf="apiBaseUrl.invalid && ((apiBaseUrl.dirty || apiBaseUrl.touched) || submitted == true)"
                            class='invalidInputTextMessage'>
                            <div *ngIf="apiBaseUrl.errors?.['required']">
                                <div>Api Base Url Required</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <label for="job-title-Input" class="form-label">Access Token</label>
                        <input disabled="true" type="text"
                            [(ngModel)]="accountingConfigurationsModel!.tokenInfo.accessToken" class="form-control"
                            id="job-title-Input" />
                    </div>
                    <div class="col-12">
                        <label for="job-title-Input" class="form-label">Refresh Token</label>
                        <input disabled="true" type="text"
                            [(ngModel)]="accountingConfigurationsModel!.tokenInfo.refreshToken" class="form-control"
                            id="job-title-Input" />
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="2" class="nav-item">
            <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                <div i18n="">Mapping Objects</div>
            </a>
            <ng-template ngbNavContent>
                <div>
                    <app-accounting-mapping-rules-list [inputModel]=accountingConfigurationsModel! ></app-accounting-mapping-rules-list>
                </div>
            </ng-template>
        </li>
    </ul>
</div>
<div class="card-body p-4">
    <div class="modal-body p-0">
        <div [ngbNavOutlet]="customNav" class="invisible-scrollbar"
            style=" overflow-y: scroll; overflow-x: hidden; min-height: 51rem; max-height:fit-content; "></div>

        <div class="pt-4 justify-content-end d-flex gap-3 align-items-end" [ngClass]="{ 'justify-content-between': (activeTab == 1) }" [ngClass]="">
            <button *ngIf="activeTab == 1" class="btn " style=" background-color: #365ebf !important; color: white !important;"
                (click)="onCreate()">
                <div class="gap-2" style="display: inline-flex; ">
                    <img class="p-0 m-0" src="assets/media/logos/quickbooks/intuitLogo.png" height="15" alt="">
                    <div style="text-align: center;" i18n="@@">Sign in with Intuit</div>
                </div>
            </button>
            <button class="btn btn-success " (click)="onUpdate()">
                <div style="display: inline-flex; ">
                    <div style="text-align: center;" i18n="@@">Update</div>
                </div>
            </button>
        </div>
    </div>